import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    LICENCESUPDATERS_RECEIVE_LIST: receiveList,
    LICENCESUPDATERS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_LICENCESUPDATERS: changeEntity,
    INVALIDATE_LICENCESUPDATERS: invalidateFilters,
    LICENCESUPDATERS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    counts: {},
    entities: {},
    result: {},
    filters: {},
}

export default createReducer(initialState, handlers)
